module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v("ABBREVIATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("ADC: African Divine Church")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("AFBFM: American Friends Board of Foreign Missions")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("AIC: African Inland Church")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("AICN: African Israel Church Nineveh")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("C.A.: Christ’s Ambassadors")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("CMS: Church Missionary Society")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("FAIM: Friends Africa Industrial Mission")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("FAM: Friends African Mission")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("GB: Golden Bells (hymnal)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("KNA: Kenya National Archives")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("NZI: Nyimbo za Injili (hymnal)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("OAU: Organization of African Unity")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PAG: Pentecostal Assemblies of God")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("PAOC: Pentecostal Assemblies of Canada")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("RS: Redemption Songs (hymnal)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("SATB: soprano, alto, tenor, bass")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("SSS: Sunday School Songs (hymnal)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("TH: Tabernacle Hymns (hymnal)")]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("TTN: Tsinyimbu tsya Nyasaye (hymnal)")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "bodytext"
  }), _vm._v(" "), _c('h1', {
    staticClass: "h1a"
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _vm._v("MUSIC IN KENYAN CHRISTIANITY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53dde613","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 84
// module chunks = 0